import { render, staticRenderFns } from "./DataPropertyManagement.vue?vue&type=template&id=11809a11"
import script from "./DataPropertyManagement.vue?vue&type=script&lang=js"
export * from "./DataPropertyManagement.vue?vue&type=script&lang=js"
import style0 from "./DataPropertyManagement.vue?vue&type=style&index=0&id=11809a11&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports